<script>
export default {
  name: "Sidebar",
  data() {
    return {
      backgroundColor: "#EAEEF1",
      textColor: "#424e67",
      activeTextColor: "#3b8cff",
    };
  },
  computed: {
    isCollapse() {
      return this.$store.state.isCollapse;
    },
    isAdmin() {
      return this.$store.state.authKey === "Admin-Token";
    },
  },
  methods: {
    isRole(role) {
      return this.$store.state.authRole.includes(role);
    },
  },
};
</script>

<template lang="pug">
.app-side-menu
  el-menu.menu.collapse-menu(
    :default-active="$route.path"
    router
    :collapse="isCollapse"
    :background-color="backgroundColor"
    :text-color="textColor"
    :active-text-color="activeTextColor"
    v-if="isAdmin")
    el-menu-item(index="/admin")
      i.fa.fa-calendar
      span(slot="title") 待办事项
    el-submenu(index="account")
      template(slot="title")
        i.fa.fa-id-card-o
        span 账号模块
      el-menu-item-group
        el-menu-item(index="/admin/orgs")
          i.el-icon-star-off
          span(slot="title") 成员管理
        el-menu-item(index="/admin/experts")
          i.el-icon-star-off
          span(slot="title") 专家管理
        el-menu-item(index="/admin/users")
          i.el-icon-star-off
          span(slot="title") 用户管理
    el-submenu(index="resource")
      template(slot="title")
        i.fa.fa-database
        span 资源模块
      el-menu-item-group
        el-menu-item(index="/admin/notifications")
          i.el-icon-star-off
          span(slot="title") 通知管理
        el-menu-item(index="/admin/templates")
          i.el-icon-star-off
          span(slot="title") 模板管理
        el-menu-item(index="/admin/materials")
          i.el-icon-star-off
          span(slot="title") 资源管理
        el-menu-item(index="/admin/medias")
          i.el-icon-star-off
          span(slot="title") 媒体管理
    el-submenu(index="meeting")
      template(slot="title")
        i.fa.fa-cog
        span 培训室管理
      el-menu-item-group
        el-menu-item(index="/admin/meeting")
          i.el-icon-star-off
          span 预约首页
        el-menu-item(index="/admin/meeting/reserve")
          i.el-icon-star-off
          span 预约管理
        el-menu-item(index="/admin/meeting/agendas")
          i.el-icon-star-off
          span 会议议程
        el-menu-item(index="/admin/meeting/appointments?state=activates")
          i.el-icon-star-off
          span 预约列表
        el-menu-item(index="/admin/meeting/appointments?state=histories")
          i.el-icon-star-off
          span 预约历史
        el-menu-item(index="/admin/meeting/rooms")
          i.el-icon-star-off
          span 培训室设置
    el-submenu(index="research")
      template(slot="title")
        i.fa.fa-joomla
        span 教改项目
      el-menu-item-group
        el-menu-item(index="/admin/research/activities")
          i.el-icon-star-off
          span 教改管理
        el-menu-item(index="/admin/research/catalogs")
          i.el-icon-star-off
          span 经费类型
        el-menu-item(index="/admin/research/funds")
          i.el-icon-star-off
          span 经费报销管理
    el-submenu(index="activities")
      template(slot="title")
        i.fa.fa-trophy
        span 比赛管理
      el-menu-item-group
        el-menu-item(index="/admin/compete/activities")
          i.el-icon-star-off
          span 比赛管理
        el-menu-item(index="/admin/stat/orgs")
          i.el-icon-star-off
          span 比赛排行


    el-menu-item(index="/admin/train/activities")
      i.fa.fa-book
      span 培训管理
    el-menu-item(index="/admin/helpCenter")
      i.fa.fa-question-circle-o
      span(slot="title") 帮助中心
    el-menu-item(index="/admin/layouts")
      i.fa.fa-indent
      span(slot="title") 模板布局管理
  el-menu.menu.collapse-menu(
    :default-active="$route.path"
    router
    :collapse="isCollapse"
    :background-color="backgroundColor"
    :text-color="textColor"
    :active-text-color="activeTextColor"
    v-else)
    el-menu-item(index="/admin")
      i.fa.fa-calendar
      span(slot="title") 待办事项
    el-submenu(index="meeting", v-if="isRole('meeting')")
      template(slot="title")
        i.fa.fa-cog
        span 培训室管理
      el-menu-item-group
        el-menu-item(index="/admin/meeting")
          i.el-icon-star-off
          span 预约首页
        el-menu-item(index="/admin/meeting/reserve")
          i.el-icon-star-off
          span 预约管理
        el-menu-item(index="/admin/meeting/agendas")
          i.el-icon-star-off
          span 会议议程
        el-menu-item(index="/admin/meeting/appointments?state=activates")
          i.el-icon-star-off
          span 预约列表
        el-menu-item(index="/admin/meeting/appointments?state=histories")
          i.el-icon-star-off
          span 预约历史
        el-menu-item(index="/admin/meeting/rooms")
          i.el-icon-star-off
          span 培训室设置
    el-submenu(index="research", v-if="isRole('research')")
      template(slot="title")
        i.fa.fa-cog
        span 教改项目
      el-menu-item-group
        el-menu-item(index="/admin/research/activities")
          i.el-icon-star-off
          span 教改管理
        el-menu-item(index="/admin/research/catalogs")
          i.el-icon-star-off
          span 经费类型
    el-menu-item(index="/admin/research/funds", v-if="isRole('expense')")
      i.fa.fa-money
      span 经费报销管理
    el-menu-item(index="/admin/compete/activities", v-if="isRole('compete')")
      i.fa.fa-trophy
      span 比赛管理
    el-menu-item(index="/admin/trains", v-if="isRole('train')")
      i.fa.fa-book
      span 培训管理
    el-menu-item(index="/admin/helpCenter")
      i.fa.fa-indent
      span(slot="title") 帮助中心
</template>

<style lang="stylus" scoped>
$collapseWidth = 64px
$sideWidth = 200px

.app-side-menu
  height 100vh
  overflow auto
  .menu
    height 100%
    border none
    .el-menu-item
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
      &:hover
        background-color #DDE2E5 !important
    .is-active
      font-weight bold
    .fa
      box-sizing content-box
      padding 5px
      width 14px
      height 14px
      text-align center
    .menu-name
      width 100%
      padding-left 10px
  .collapse-menu:not(.el-menu--collapse)
    width $sideWidth
  .collapse-menu
    width $collapseWidth
</style>



// WEBPACK FOOTER //
// Sidebar.vue?47bf9b92